import { render, staticRenderFns } from "./confirmPay.vue?vue&type=template&id=1180308c&scoped=true"
import script from "./confirmPay.vue?vue&type=script&lang=js"
export * from "./confirmPay.vue?vue&type=script&lang=js"
import style0 from "./confirmPay.vue?vue&type=style&index=0&id=1180308c&prod&scoped=true&lang=css"
import style1 from "./confirmPay.vue?vue&type=style&index=1&id=1180308c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180308c",
  null
  
)

export default component.exports